import { useState, useEffect } from "react";
import { Alert, Badge, Button, Col, Container, FloatingLabel, Form, InputGroup, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { updateMachineAsync } from "./api";


export default function MachineUpdate({ item, jwt, onHide, onUpdate, show, }) {
    const categoriesAll = [
        { id: 1, name: 'Лазерные станки' },
        { id: 2, name: 'УФ-станки' },
        { id: 3, name: 'Литейные станки' },
    ];
    const [machineName, setMachineName] = useState('');
    const [machineDescription, setMachineDescription] = useState('');
    const [isLive, setIsLive] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [machineCategoryId, setMachineCategoryId] = useState(0);

    useEffect(() => {
        console.log(item);
        setMachineName(item.name);
        setIsLive(item.isLive);
        setMachineDescription(item.description);
        setMachineCategoryId(item.categoryId);
        setSelectedCategory(categoriesAll.find(o => o.id == item.categoryId));
    }, []);


    const onSubmit = async (e) => {
        e.preventDefault();

        if (machineName == null || machineName == '') {
            alert('Введите имя');
            return;
        }

        if (machineCategoryId == 0) {
            alert('Некорректная категория');
            return;
        }

        try {
            const machineResponse = await updateMachineAsync(item.id, {
                name: machineName,
                description: machineDescription,
                isLive: isLive,
                categoryId: machineCategoryId
            }, jwt);

            if (!machineResponse) {
                alert('Ошибка при обновлении станка');
                return;
            }
            alert(`Обновлен станок "${machineResponse.name}" с id ${machineResponse.id}`)
            onUpdate({
                name: machineResponse.name, id: machineResponse.id, description: machineDescription, isLive: isLive,
                categoryId: machineCategoryId
            });
            onHide();

        } catch (error) {
            console.error('Ошибка при обновлении станка:', error);
            alert('Произошла ошибка при обновлении станка');
        }
    }

    return <Modal show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Form onSubmit={onSubmit}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span>Обновление станка</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <h5>Имя</h5>
                        <InputGroup className="mb-3">
                            <Form.Control
                                type='text'
                                value={machineName}
                                onChange={e => setMachineName(e.target.value)}
                            />
                        </InputGroup>
                    </Row>
                    <Row>
                        <h5>Описание</h5>
                        <InputGroup className="mb-3">
                            <Form.Control
                                type='text'
                                value={machineDescription}
                                onChange={e => setMachineDescription(e.target.value)}
                            />
                        </InputGroup>
                    </Row>
                    <Row>
                        <h5>Категория</h5>
                        <Form.Select
                            value={selectedCategory?.id || ""}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedCategory = categoriesAll.find(c => c.id === (selectedId ? Number(selectedId) : null));
                                setSelectedCategory(selectedCategory || null);
                                setMachineCategoryId(selectedId);
                            }}
                            style={{ maxWidth: 300 }}
                        >
                            <option value="">Выберите категорию</option>
                            {categoriesAll.map(category => (
                                <option key={category.id} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Form.Check
                    type="switch"
                    className="me-auto"
                    checked={isLive}
                    onChange={e => setIsLive(e.target.checked)}
                    label={'Станок активен'} />
                <Button variant="secondary" onClick={onHide}>Закрыть</Button>
                <Button variant="success" type="submit">Сохранить</Button>
            </Modal.Footer>
        </Form>
    </Modal>
}